import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import warning from 'warning';
import PropTypes from 'prop-types';
import { isVertical } from './utils';

var TabBarTabsNode = /*#__PURE__*/function (_React$Component) {
  _inherits(TabBarTabsNode, _React$Component);

  var _super = _createSuper(TabBarTabsNode);

  function TabBarTabsNode(props) {
    _classCallCheck(this, TabBarTabsNode);

    return _super.call(this, props);
  }

  _createClass(TabBarTabsNode, [{
    key: "onTabClick",
    value: function onTabClick(key) {
      this.props.onTabClick(key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.panels,
          activeKey = _this$props.activeKey,
          clsPrefix = _this$props.clsPrefix,
          tabBarGutter = _this$props.tabBarGutter,
          saveRef = _this$props.saveRef,
          tabBarPosition = _this$props.tabBarPosition,
          renderTabBarNode = _this$props.renderTabBarNode,
          direction = _this$props.direction;
      var rst = [];
      React.Children.forEach(children, function (child, index) {
        if (!child) {
          return;
        }

        var key = child.key;
        var cls = activeKey === key ? "".concat(clsPrefix, "-tab-active") : '';
        cls += " ".concat(clsPrefix, "-tab");
        var events = {};

        if (child.props.disabled) {
          cls += " ".concat(clsPrefix, "-tab-disabled");
        } else {
          events = {
            onClick: _this.onTabClick.bind(_this, key)
          };
        }

        var ref = {};

        if (activeKey === key) {
          ref.ref = saveRef('activeTab');
        }

        var gutter = tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter;
        var marginProperty = direction === 'rtl' ? 'marginLeft' : 'marginRight';

        var style = _defineProperty({}, isVertical(tabBarPosition) ? 'marginBottom' : marginProperty, gutter);

        warning('tab' in child.props, 'There must be `tab` property on children of Tabs.');
        var node = /*#__PURE__*/React.createElement("div", _extends({
          role: "tab",
          "aria-disabled": child.props.disabled ? 'true' : 'false',
          "aria-selected": activeKey === key ? 'true' : 'false'
        }, events, {
          className: cls,
          key: key,
          style: style
        }, ref, {
          nid: child.props.nid,
          uitype: child.props.uitype,
          nodekey: key
        }), child.props.tab);

        if (renderTabBarNode) {
          node = renderTabBarNode(node);
        }

        rst.push(node);
      });
      return /*#__PURE__*/React.createElement("div", {
        ref: saveRef('navTabsContainer')
      }, rst);
    }
  }]);

  return TabBarTabsNode;
}(React.Component);

export { TabBarTabsNode as default };
TabBarTabsNode.propTypes = {
  activeKey: PropTypes.string,
  panels: PropTypes.node,
  clsPrefix: PropTypes.string,
  tabBarGutter: PropTypes.number,
  onTabClick: PropTypes.func,
  saveRef: PropTypes.func,
  renderTabBarNode: PropTypes.func,
  tabBarPosition: PropTypes.string,
  direction: PropTypes.string
};
TabBarTabsNode.defaultProps = {
  panels: [],
  clsPrefix: [],
  tabBarGutter: null,
  onTabClick: function onTabClick() {},
  saveRef: function saveRef() {}
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/TabBarTabsNode.js